"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.definePhoneCSS = exports.default = exports.PhoneToolbox = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PhoneToolbox = function PhoneToolbox(Survey) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  var phoneToolbox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var widget = _objectSpread(_objectSpread({}, phoneToolbox), {}, {
    defaultTitle: t(phoneToolbox.title),
    questionJSON: _objectSpread(_objectSpread({}, phoneToolbox.json), {}, {
      type: 'text'
    })
  });
  Survey.ComponentCollection.Instance.add(widget);
};
exports.PhoneToolbox = PhoneToolbox;
var _default = PhoneToolbox;
exports.default = _default;
var definePhoneCSS = function definePhoneCSS(survey) {
  survey.onUpdateQuestionCssClasses.add(function (_, options) {
    var classes = options.cssClasses;
    if (options.question.getType() === _constants.MODEL_QUESTIONS.PHONE) {
      classes.title = "".concat(classes.title, " phone-toolbox-title");
    }
  });
};
exports.definePhoneCSS = definePhoneCSS;